// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2wK-h","productName":"Table_productName__1-zoQ"};